export default __webpack_public_path__ + "static/media/nfo-banner-consumption-comp.1a9b13fb.jpg";